import { Slider as SliderPrimitive } from "@base-ui/react/slider";

import { cn } from "@/lib/utils";

function AudioSlider({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  withThumb = true,
  withTrack = true,
  ...props
}: SliderPrimitive.Root.Props & {
  withThumb?: boolean;
  withTrack?: boolean;
}) {
  const _values = Array.isArray(value)
    ? value
    : Array.isArray(defaultValue)
      ? defaultValue
      : [min, max];

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      className={cn(
        "data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Control className="relative flex w-full touch-none items-center select-none data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col">
        <SliderPrimitive.Track
          data-slot="slider-track"
          className="bg-slider relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-2.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
        >
          {withTrack && (
            <SliderPrimitive.Indicator
              data-slot="slider-range"
              className="bg-primary rounded-full"
            />
          )}
        </SliderPrimitive.Track>
        {withThumb
          ? Array.from({ length: _values.length }, (_, index) => (
              <SliderPrimitive.Thumb
                data-slot="slider-thumb"
                key={index}
                index={index}
                className="block shrink-0 rounded-full bg-black transition-[color,box-shadow] focus-visible:outline-hidden data-[disabled]:pointer-events-none w-0.5 h-5"
              />
            ))
          : null}
      </SliderPrimitive.Control>
    </SliderPrimitive.Root>
  );
}

export { AudioSlider };
